import React, { useState } from 'react';

// import pages
import PageHome from 'js/page/Page.home';
import Modal from 'js/components/modal/Modal';

// context
import { AudioProvider } from 'js/context/AudioContext';
import { DataProvider } from 'js/context/DataContext';

const App = () => {
  const [modalType, setModalType] = useState(false);
  const toggleModal = (type) => {
    setModalType(type == modalType ? false : type);
  };

  return (
    <DataProvider>
      <AudioProvider>
        <Modal modalType={modalType} toggleModal={toggleModal} />
        <PageHome toggleModal={toggleModal} />
      </AudioProvider>
    </DataProvider>
  );
};

export default App;
